document.addEventListener('DOMContentLoaded', function() {
  var hamburger = document.querySelector('.hamburger-init'),
      menu_wrapper = document.querySelector('.menu-wrapper'),
      sidebar_background = document.querySelector('.sidebar-background');
    
  hamburger.addEventListener('click', function() {
    document.querySelector('.container').classList.toggle('hamburger-guide');
    this.classList.toggle('active');
    sidebar_background.classList.toggle('visible');
  });

  sidebar_background.addEventListener('click', function(e) {
    // Check if the click target is the sidebar background itself (not a child element)
    if (e.target === sidebar_background) {
      document.querySelector('.container').classList.remove('hamburger-guide');
      hamburger.classList.remove('active');
      sidebar_background.classList.remove('visible');
    }
  });
});


    document.addEventListener('DOMContentLoaded', function() {
        // Track currently open subnav
        let currentOpenSubnav = null;
        
        // Close subnav when clicking outside
        document.addEventListener('click', function(e) {
            if (currentOpenSubnav && !currentOpenSubnav.contains(e.target)) {
                closeSubnav(currentOpenSubnav);
                currentOpenSubnav = null;
            }
        });
        
        // Process all navigation lists with the class 'header-nav-list'
        const navLists = document.querySelectorAll('.menu-wrapper .header-nav-list');
        
        navLists.forEach(navList => {
            const navItems = navList.querySelectorAll('li');
            let prevItem = null;
            let subItems = [];
            
            navItems.forEach((item, index) => {
                const label = item?.children[0]?.innerHTML?.trim();
                
                if (label && label.startsWith('--')) {
                    // This is a submenu item
                    subItems.push({
                        link: item.innerHTML,
                        classes: Array.from(item.classList),
                        node: item
                    });
                } else {
                    // Process any accumulated subitems before moving to the next main item
                    if (subItems.length > 0 && prevItem) {
                        createSubmenu(prevItem, subItems, navList);
                        subItems = [];
                    }
                    
                    // Set this as the new previous item
                    prevItem = item;
                }
                
                // Handle the case where the last items are submenu items
                if (index === navItems.length - 1 && subItems.length > 0 && prevItem) {
                    createSubmenu(prevItem, subItems, navList);
                }
            });
        });
        
        function createSubmenu(parentItem, subItems, navList) {
            // Create dropdown icon
            const dropdownIcon = document.createElement('span');
            dropdownIcon.className = 'dropdown-icon';
            dropdownIcon.innerHTML = '&rsaquo;';
            
            // Create submenu container
            const subNav = document.createElement('ul');
            subNav.className = 'subnav-menu';
            subNav.style.display = 'none';

            // Create and add the parent item to the submenu
            const parentItemClone = parentItem.cloneNode(true);
            parentItemClone.classList.add('nav-parent');
            subNav.appendChild(parentItemClone);
            
            // Add subitems to submenu
            subItems.forEach(subItem => {
                const li = document.createElement('li');
                li.className = subItem.classes.join(' ');
                li.innerHTML = subItem.link.replace('--', '').trim();
                subNav.appendChild(li);
                
                // Remove original node from DOM
                if (subItem.node && subItem.node.parentNode) {
                    subItem.node.parentNode.removeChild(subItem.node);
                }
            });
            
            // Wrap the original link content
            const originalLink = parentItem.querySelector('a');
            const linkContent = originalLink.innerHTML;
            const linkUrl = originalLink.getAttribute('href');
            
            // Create new link structure
            const newLink = document.createElement('a');
            newLink.href = linkUrl;
            newLink.innerHTML = linkContent;
            newLink.appendChild(dropdownIcon);
            
            // Replace original content
            parentItem.innerHTML = '';
            parentItem.appendChild(newLink);
            parentItem.appendChild(subNav);
            
            // Update classes
            parentItem.classList.remove('nav-current');
            parentItem.classList.add('has-subnav');
            parentItem.classList.add('nav-wrapper');
            
            // Add click event for toggle
            parentItem.addEventListener('click', function(e) {
                const mediaQuery = window.matchMedia('(max-width: 767px)');
                // Don't toggle if clicking on a link in the subnav
                if (e.target.tagName === 'A' && e.target !== newLink) {
                    return;
                }

                if (mediaQuery.matches) {
                    e.preventDefault();
                }

                e.stopPropagation();
                
                // Close any currently open subnav
                if (currentOpenSubnav && currentOpenSubnav !== parentItem) {
                    closeSubnav(currentOpenSubnav);
                }
                
                // Toggle current subnav
                if (subNav.style.display === 'block') {
                    closeSubnav(parentItem);
                    currentOpenSubnav = null;
                } else {
                    openSubnav(parentItem);
                    currentOpenSubnav = parentItem;
                }
            });
        }
        
        function openSubnav(parentItem) {
            const subNav = parentItem.querySelector('.subnav-menu');
            subNav.style.display = 'block';
            parentItem.classList.add('subnav-open');
        }
        
        function closeSubnav(parentItem) {
            const subNav = parentItem?.querySelector('.subnav-menu');
            if (subNav) {
                subNav.style.display = 'none';
                parentItem.classList.remove('subnav-open');
            }
        }
    });